import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "../Components/Header"; // adjust path if needed

const StudentMyMembership = () => {
  const navigate = useNavigate();

  // 🔹 STATIC DATA (replace with API later)
  const staticMemberships = [
    {
      id: 1,
      name: "Basic Membership",
      plan: "Basic",
      status: "Active",
      startDate: "2024-08-01",
      endDate: null,
      price: "Free",
      benefits: [
        "Access to free courses",
        "Community access",
      ],
    },
    {
      id: 2,
      name: "Premium Membership",
      plan: "Premium",
      status: "Expired",
      startDate: "2023-06-01",
      endDate: "2024-06-01",
      price: "₹1999",
      benefits: [
        "All premium courses",
        "Certificates",
        "Priority support",
      ],
    },
  ];

  const [memberships, setMemberships] = useState([]);

  // 🔁 Future API replacement goes here
  useEffect(() => {
    setMemberships(staticMemberships);
  }, []);

  return (
    <>
      <Header />

      <Container style={{ marginTop: "90px", marginBottom: "40px" }}>
        {/* BACK BUTTON */}
        <div style={{ marginBottom: "20px" }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              background: "transparent",
              border: "none",
              color: "#B8529E",
              fontWeight: "600",
              fontSize: "15px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              cursor: "pointer",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#f4811e")}
            onMouseLeave={(e) => (e.target.style.color = "#B8529E")}
          >
            ← Back
          </button>
        </div>

        {/* PAGE TITLE */}
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <h1
            style={{
              fontWeight: "900",
              fontSize: "34px",
              background: "linear-gradient(90deg, #f4811e, #B8529E, #3953A3)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            My Memberships
          </h1>
          <p style={{ color: "#6c757d", maxWidth: "500px", margin: "0 auto" }}>
            View and manage your active and past memberships
          </p>
        </div>

        {/* MEMBERSHIP LIST */}
        {memberships.length === 0 ? (
          <div style={{ textAlign: "center", color: "#777", padding: "40px" }}>
            You don’t have any memberships yet.
          </div>
        ) : (
          <Row>
            {memberships.map((m) => (
              <Col md={6} lg={4} className="mb-4" key={m.id}>
                <Card
                  className="h-100 border-0"
                  style={{
                    borderRadius: "14px",
                    boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                  }}
                >
                  <Card.Body>
                    {/* HEADER */}
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h5 className="fw-bold mb-0">{m.name}</h5>
                      <Badge
                        style={{
                          background:
                            m.status === "Active"
                              ? "linear-gradient(45deg,#28a745,#20c997)"
                              : "linear-gradient(45deg,#6c757d,#adb5bd)",
                          padding: "6px 12px",
                          borderRadius: "20px",
                          fontSize: "12px",
                        }}
                      >
                        {m.status}
                      </Badge>
                    </div>

                    <p className="text-muted mb-2">{m.plan} Plan</p>

                    {/* DETAILS */}
                    <p className="mb-1">
                      <strong>Price:</strong> {m.price}
                    </p>
                    <p className="mb-1">
                      <strong>Start:</strong> {m.startDate}
                    </p>
                    <p className="mb-3">
                      <strong>End:</strong> {m.endDate || "Lifetime"}
                    </p>

                    {/* BENEFITS */}
                    <strong>Benefits:</strong>
                    <ul style={{ paddingLeft: "18px", marginTop: "6px" }}>
                      {m.benefits.map((b, i) => (
                        <li key={i} style={{ fontSize: "14px" }}>
                          {b}
                        </li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </>
  );
};

export default StudentMyMembership;
